import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34f36aba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropShadow" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-color mr-4 font-weight-bold" }, "Powered by", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "d-flex flex-wrap align-center mt-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-color mr-2" }, "We accept", -1))
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]

import visa from "@/assets/images/icon-visa.svg";
import master from "@/assets/images/icon-master.svg";
import bank from "@/assets/images/icon-bank.svg";
import applePay from "@/assets/images/icon-apple-pay.svg";
import paypal from "@/assets/images/icon-paypal-logo.svg";
import googlePay from "@/assets/images/icon-google-pay-logo.svg";
import pix from "@/assets/images/icon-pix-logo.svg";
import simplex from "@/assets/images/icon-simplex.png";
import coinbase from "@/assets/images/icon-coinbase.webp";
import coinbaseLight from "@/assets/images/icon-coinbase-light.webp";
import simplexLight from "@/assets/images/icon-simplex-light.png";
import moonpay from "@/assets/images/icon-moonpay.svg";
import moonpayWhite from "@/assets/images/icon-moonpay-white.svg";
import topper from "@/assets/images/icon-topper.svg";
import topperDark from "@/assets/images/icon-topper-dark.svg";
import enkryptDarkLogo from "@/assets/images/icon-enkrypt-logo-dark.svg";
import ethvmLogo from "@/assets/images/icon-ethvm-logo.svg";
import mewLogo from "@/assets/images/icon-mew-logo-dark.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const isEthVm = window.location.search.includes("platform=ethvm");
const isEnkrypt = window.location.search.includes("platform=enkrypt");

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(isEthVm) ? _unref(ethvmLogo) : _unref(isEnkrypt) ? _unref(enkryptDarkLogo) : _unref(mewLogo),
      alt: "MEW",
      height: "36"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: "heading-1 text-color",
      style: _normalizeStyle(
        _ctx.$vuetify.display.smAndUp
          ? 'margin-top: 100px; max-width: 520px'
          : 'margin-top: 50px;  max-width: 520px'
      )
    }, " Buy and Sell Crypto Fast and Secure ", 4),
    _createVNode(_component_v_row, {
      class: "mt-15",
      "no-gutters": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          sm: "5",
          class: "pt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(isEthVm) ? _unref(moonpayWhite) : _unref(moonpay),
              alt: "Moonpay",
              width: "100%",
              style: {"max-width":"140px"}
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          sm: "5",
          class: "pt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              class: "mr-2",
              src: _unref(isEthVm) ? _unref(simplexLight) : _unref(simplex),
              alt: "Simplex",
              width: "100%",
              style: {"max-width":"140px"}
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          sm: "5",
          class: "pt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(isEthVm) ? _unref(topperDark) : _unref(topper),
              alt: "Topper",
              width: "100%",
              style: {"max-width":"140px"}
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          sm: "5",
          class: "pt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(isEthVm) ? _unref(coinbase) : _unref(coinbaseLight),
              alt: "Coinbase",
              width: "100%",
              style: {"max-width":"140px"}
            }, null, 8, _hoisted_7)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(visa),
          alt: "Visa",
          height: "28"
        }, null, 8, _hoisted_11),
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(master),
          alt: "Master",
          height: "28"
        }, null, 8, _hoisted_12),
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(bank),
          alt: "Master",
          height: "28"
        }, null, 8, _hoisted_13),
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(paypal),
          alt: "paypal",
          height: "42"
        }, null, 8, _hoisted_14),
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(applePay),
          alt: "Visa",
          height: "28"
        }, null, 8, _hoisted_15),
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(googlePay),
          alt: "google pay",
          height: "42"
        }, null, 8, _hoisted_16),
        _createElementVNode("img", {
          class: "mr-2",
          src: _unref(pix),
          alt: "pix",
          height: "28"
        }, null, 8, _hoisted_17)
      ])
    ])
  ]))
}
}

})